import { CONTACT_POINT_SYSTEM, REGEX_EXPS } from "utils/constants";
import {
  createCityNameValidation,
  createContractNumberValidation,
} from "utils/helpers/validations";
import * as yup from "yup";

const validation = (messages, { hasRia, occupation }) => {
  const string = yup
    .string()
    .typeError(messages.REQUIRED)
    .required(messages.REQUIRED);

  const cityName = createCityNameValidation(messages, REGEX_EXPS);
  const contractNumber = createContractNumberValidation(messages, REGEX_EXPS);

  return yup.object().shape({
    project: yup.object().shape({
      contract: yup.object().shape({
        issuanceDate: yup.date().typeError(messages.REQUIRED),
      }),
      fields: yup.object().shape({
        selfOccupation: yup.boolean().oneOf([true, false], " "),
      }),
      ...(hasRia &&
        !occupation && {
          terminationRequest: yup.object().shape({
            dueDate: yup.date().typeError(messages.REQUIRED),
            contractNumber: contractNumber,
            recipient: string,
            reason: string,
          }),
        }),
    }),
    telecoms: yup.object().shape({
      [CONTACT_POINT_SYSTEM.BIRTH_CITY]: yup.object().shape({
        value: cityName,
      }),
      [CONTACT_POINT_SYSTEM.BIRTH_COUNTRY]: yup.object().shape({
        value: string,
      }),
      [CONTACT_POINT_SYSTEM.DEPARTMENT_OF_BIRTH]: yup.object().shape({
        value: string,
      }),
    }),
  });
};

export default validation;
